import type { Product } from '~/stores/CategoriesStore/Product';

import type { RecommendationConfig } from './types';

const sortByBought = (products: Product[]): Product[] => {
  return [...products].sort((a, b) => {
    if (a.isBought && !b.isBought) {
      return -1;
    }
    if (!a.isBought && b.isBought) {
      return 1;
    }
    return 0;
  });
};

export const TOP_PICKS_CONFIG: RecommendationConfig = {
  source: 'top_picks',
  id: 'top-picks',
  nameKey: 'recommendations:topPicks',
  linkId: 'top-picks-sub',
  companyFlag: 'showTopPicksSlider',
  hideBadges: true,
  size: 'm',
};

export const ORDER_AGAIN_CONFIG: RecommendationConfig = {
  source: 'order_again',
  id: 'order-again',
  nameKey: 'recommendations:orderAgain',
  linkId: 'order-again-sub',
  companyFlag: 'showOrderAgainSlider',
  sortProducts: sortByBought,
  hideBadges: false,
  size: 's',
};
